<button class="btn btn-sm btn-primary" (click)="openSetupTiktokFlashSaleModal()">
  <i class="fas fa-ad"></i>
</button>

<ng-template #setupTiktokFlashSaleModal let-modal>
  <form [formGroup]="setupFlashSaleForm" (ngSubmit)="setupTiktokFlashSaleApi()">
    <div class="modal-header">
      <h4 class="modal-title">
        Tiktok FlashSale cho <strong>{{merchant.name}}</strong>
      </h4>
      <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">

      <div class="form-group form-check">
        <input type="checkbox" class="form-check-input" id="IsActivated" formControlName="isActivated">
        <label class="form-check-label" for="IsActivated">Bật</label>
      </div>
      <div class="form-group">
        <label>Discount %</label>
        <input type="number" class="form-control" formControlName="discount" required>
      </div>
      <div class="form-group">
        <label>Thời gian bắt dầu</label>
        <input type="datetime-local" class="form-control" name="startTime" formControlName="startTime" required>
      </div>
      <div class="form-group">
        <label>Thời hạn sale (đơn vị giờ)</label>
        <input type="number" class="form-control" name="hourDuration" formControlName="hourDuration" required>
      </div>
      <div class="form-group form-check">
        <input type="checkbox" class="form-check-input" id="IsAutoRenew" formControlName="isAutoRenew">
        <label class="form-check-label" for="IsAutoRenew">Auto Renew</label>
      </div>
      <div class="form-group form-check">
        <label>Note</label>
        <p [innerHTML]="note"></p>
      </div>

    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-light" (click)="modal.close('Close click')">Cancel</button>
      <button type="button" class="btn btn-outline-info" (click)="priority()">Ưu tiên chạy</button>
      <button type="submit" class="btn btn-primary">Lưu</button>
    </div>
  </form>
</ng-template>
